// Лейбл для бейджа в карточке/сниппете оффера
export default {
    newBuilding: 'Новостройка',
    fromDeveloper: 'От застройщика',
    newBuildingFromDeveloper: 'Новостройка от застройщика',
    inPledge: 'В залоге',
    pit: 'Имущественные торги',
    onlineView: 'Онлайн-просмотр'
};
